export class NodeFile {
  
    name?:string;
   
    children?:NodeFile[]=[];
    webUrl?:string;


}